import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoFaqWithImg, { EcoFaqWithImgItemProps } from 'eco-design/sections/eco-faq-win-img';
import styles from './index.module.scss';
import EfSection from '@elem/ui/ef-section';

const JK: React.FC = () => {
    const { t } = useLang('delta3series');
    const items: EcoFaqWithImgItemProps[] = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1741058987044/app1.jpg',
            title: t('K_item1_title'),
            desc: t('K_item1_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1741058987380/app2.jpg',
            title: t('K_item2_title'),
            desc: t('K_item2_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1741058987192/app3.jpg',
            title: t('K_item3_title'),
            desc: t('K_item3_desc'),
        },
    ];

    return (
        <div className={styles.comp} id="d3-K">
            <EcoSpace />
            <EfSection label={t('K_label')} title={t('K_title')} />
            <EcoSpaceSmall />
            <EcoFaqWithImg items={items} />
        </div>
    );
};

export default JK;
